import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Trash2, Loader2 } from 'lucide-react';

// Delete Session Dialog (admin only)
export const DeleteSessionDialog = ({ deleting, onClose, busy, reason, setReason, onConfirm }) => (
  <Dialog open={!!deleting} onOpenChange={(o) => !o && !busy && onClose()}>
    <DialogContent className="max-w-md" data-testid="pw-delete-dialog" onCloseAutoFocus={(e) => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Trash2 className="w-5 h-5 text-red-400" /> Delete time entry
        </DialogTitle>
        <DialogDescription>
          Permanently remove this time entry from payroll. Use this when a worker clocked in by mistake (e.g. on a day off). The deletion is recorded for audit.
        </DialogDescription>
      </DialogHeader>
      {deleting && (
        <div className="text-sm rounded-lg p-3 my-1" style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.25)', color: '#F0A0A0' }}>
          <span className="font-semibold">{deleting.worker.worker_name}</span> — {deleting.session.date}
          {deleting.session.clock_in && <span> · in {new Date(deleting.session.clock_in).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}</span>}
          {deleting.session.hours != null && <span> · {Number(deleting.session.hours).toFixed(2)}h</span>}
        </div>
      )}
      <div>
        <Label className="text-xs">Reason for deletion</Label>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          placeholder="e.g. Worker clocked in on a scheduled day off — entry created in error."
          data-testid="pw-delete-reason"
        />
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose} disabled={busy} data-testid="pw-delete-cancel">Cancel</Button>
        <Button
          onClick={onConfirm}
          disabled={busy || !reason.trim()}
          className="bg-red-600 hover:bg-red-700 text-white"
          data-testid="pw-delete-confirm"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Delete Entry'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
